import React, { useMemo, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-enterprise";
import { Box } from "@mui/material";

// LENDMARQ DIVERGENCE from tpo-portal-frontend: this repo is on AG Grid v33,
// tpo on v32. v33 requires modules to be registered before a grid mounts (v32
// registered them implicitly), so the wrapper does it at import time — the same
// thing lendmarq-los's own AgGridTableWrapper does. No CSS theme is imported:
// v33's Theming API supplies Quartz by default, and pulling in a legacy
// stylesheet here would put the grid into legacy mode and drop the styling.
ModuleRegistry.registerModules([AllCommunityModule]);

const DEFAULT_COL_DEF = {
  flex: 1,
  minWidth: 120,
  resizable: true,
  sortable: true,
  filter: true,
  suppressMovable: false,
  // Hide the header funnel + three-dot menu buttons by default; sorting/filtering
  // still work (header click to sort, programmatic/floating filters) — callers can
  // re-enable per column by overriding these in their columnDefs.
  suppressHeaderFilterButton: true,
  suppressHeaderMenuButton: true,
};

const AgGridTableWrapper = ({
  columnDefs,
  rowData,
  onRowClicked,
  onGridReady,
  height = 520,
  // Size to the rows instead of a fixed height — for grids nested inside
  // something that measures its own content (e.g. an auto-height detail row).
  autoHeight = false,
  rowSelection = "single",
  pagination = true,
  paginationPageSize = 25,
  defaultColDef,
  sx,
  ...extra
}) => {
  const mergedDefault = useMemo(
    () => ({ ...DEFAULT_COL_DEF, ...(defaultColDef || {}) }),
    [defaultColDef],
  );

  const handleGridReady = useCallback(
    (params) => {
      if (onGridReady) onGridReady(params);
    },
    [onGridReady],
  );

  return (
    <Box
      className="ag-theme-quartz"
      sx={{
        height: autoHeight ? "auto" : height,
        width: "100%",
        "--ag-borders": "none",
        "--ag-row-border-color": (theme) => theme.palette.divider,

        "--ag-cell-horizontal-padding": "20px",
        ...sx,
      }}
    >
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        defaultColDef={mergedDefault}
        onRowClicked={onRowClicked}
        onGridReady={handleGridReady}
        animateRows
        domLayout={autoHeight ? "autoHeight" : undefined}
        rowSelection={rowSelection}
        pagination={pagination}
        paginationPageSize={paginationPageSize}
        tooltipShowDelay={400}
        {...extra}
      />
    </Box>
  );
};

export default AgGridTableWrapper;
